import { Action, createReducer } from '@ngrx/store'
import { addDisputeReasonGroupsReducers } from './add-dispute-reason-groups/add-dispute-reason-groups.reducer'
import { loadDisputeReasonGroupsReducers } from './load-dispute-reason-groups/load-dispute-reason-groups.reducer'
import { updateDisputeReasonGroupReducers } from './update-dispute-reason-group/update-dispute-reason-group.reducer'
import {
  DisputeReasonGroupsState,
  initialDisputeReasonGroupsState
} from './dispute-reason-groups.state'

// Re-exported from the leaf state module for backward compatibility with
// existing importers of this file.
export {
  disputeReasonGroupsAdapter,
  DISPUTE_REASON_GROUPS_FEATURE_KEY,
  initialDisputeReasonGroupsState
} from './dispute-reason-groups.state'
export type { DisputeReasonGroupsState } from './dispute-reason-groups.state'

const reducer = createReducer(
  initialDisputeReasonGroupsState,
  ...loadDisputeReasonGroupsReducers,
  ...addDisputeReasonGroupsReducers,
  ...updateDisputeReasonGroupReducers
)

export function disputeReasonGroupsReducer(
  state: DisputeReasonGroupsState,
  action: Action
) {
  return reducer(state, action)
}
